const noop = state => state;

export const createReducer = ({ initialState, reducers }) => (state = initialState, action) =>
  (reducers[action.type] || noop)(state, action);
